import { render, staticRenderFns } from "./ProcedureCreate.vue?vue&type=template&id=330a2c30&scoped=true"
import script from "./ProcedureCreate.vue?vue&type=script&lang=js"
export * from "./ProcedureCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a2c30",
  null
  
)

export default component.exports